module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fyd-body"
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 2,
      "lg": 3
    }
  }, [_c('div', {
    staticClass: "library_left_side"
  }, [_c('h4', {
    staticClass: "cation"
  }, [_vm._v("分类列表")]), _vm._v(" "), _vm._l((_vm.navArray), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      class: ['library_nav_item', (index == _vm.currNav) ? 'main_nav_chg_bgc' : ''],
      on: {
        "click": function($event) {
          return _vm.switchNav(index)
        }
      }
    }, [_c('p', {
      staticStyle: {
        "line-height": "38px",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item))])])])
  })], 2)]), _vm._v(" "), _c('el-col', {
    staticClass: "library_right_side",
    staticStyle: {
      "padding": "0 !important"
    },
    attrs: {
      "xs": 24,
      "sm": 21,
      "md": 21,
      "lg": 21
    }
  }, [_c('div', {
    staticClass: "library_right_side"
  }, [(_vm.currNav == 0) ? _c('publishBook', {
    on: {
      "gotoBook": _vm.gotoBookHandle
    }
  }) : (_vm.currNav == 1) ? _c('bookNewList', {
    attrs: {
      "editCPId": _vm.editCPId,
      "editCPName": _vm.editCPName
    }
  }) : (_vm.currNav == 2) ? _c('albumNewList') : _vm._e()], 1)])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e1ee57","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/receiveBook.vue
// module id = 681
// module chunks = 1